<template>
  <div
    id="scroll-element"
    class="bg-image-content bg-content-home"
    :style="background"
  >
    <div class="home">
      <Navbar></Navbar>
      <mini-cart></mini-cart>
      <products></products>
      <AllergensLegend></AllergensLegend>
    </div>
    <QrValidationModal :check-q-r="false"></QrValidationModal>
    <Footer></Footer>

    <v-btn
      @click="toTop"
      v-show="fab"
      v-scroll:#scroll-element="onScroll"
      fixed
      dark
      fab
      bottom
      right
      color="transparent"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Navbar from "../../components/public/common/Navbar";
import Footer from "../../components/public/common/Footer";
import MiniCart from "../../components/public/cart/MiniCart";
import Products from "../../components/public/products/Products.vue";
import QrValidationModal from "../../components/public/modals/QrValidationModal.vue";
import AllergensLegend from "@/components/public/products/Allergens/AllergensLegend";
import { qrCollection } from "@/collections/qrs";

export default {
  name: "home",
  components: {
    AllergensLegend,
    Products,
    Navbar,
    MiniCart,
    Footer,
    QrValidationModal
  },
  data: () => ({
    fab: false,
    qrCollection: []
  }),
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  watch: {
    settings: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$background.$emit("start", newValue.qrExpiry);
        }
      }
    }
  },
  computed: {
    backgroundUrl() {
      return this.settings && this.settings.icons
        ? this.settings.icons.background
        : "";
    },
    background() {
      let style =
        "background-repeat: repeat; background-position: 0 0; background-size: inherit;";
      return `${style} background-image:  url(${this.backgroundUrl})`;
    }
  },
  created() {
    if (!this.settings) {
      this.getSettings();
    }
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit("setActivesQR", this.qrCollection);
    }, 1000);
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      document
        .getElementById("scroll-element")
        .scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped lang="scss">
@media only screen and (min-width: 1100px) {
  .bg-content-home {
    position: absolute;
    left: 6px;
    width: calc(100% - 5px);
  }
}

.v-toolbar {
  width: 85%;
  margin: 0 auto;
  min-width: 320px;
  max-width: 100%;

  @media only screen and (max-width: 991px) {
    width: 100%;
  }
}
</style>
